import React, { Component, Children } from 'react'
import PropTypes from 'prop-types'
import { Centrifuge } from 'centrifuge'

class Manager extends Centrifuge {
  constructor (...args) {
    super(...args)
    this.subscriptions = {}
  }

  subscribe(channel, events) {
    if(!(channel in this.subscriptions)) {
      this.subscriptions[channel] = super.newSubscription(channel);
      this.subscriptions[channel].subscribe();
    }
    this.subscriptions[channel].on("publication", events);

    return {
      "unsubscribe": () => {
        this.subscriptions[channel].removeListener("publication", events);
      }
    };
  }

  getSubscription(channel) {
    const sub = this.subscriptions[channel];
    if (!sub) {
      return null;
    }

    return sub;
  }
}

export default class Provider extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    onConnect: PropTypes.func,
    url: PropTypes.string.isRequired,
    token: PropTypes.string,
    config: PropTypes.shape({
      insecure: PropTypes.bool
    })
  }

  static defaultProps = {
    onConnect: null,
    config: {
      insecure: false
    }
  }

  static childContextTypes = {
    cent: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.props = props;
    this.init(props.token);
  }

  init(token) {
    this.cent = new Manager(this.props.url, {
      ...this.props.config,
      token: token,
    })
    if(this.props.onConnect) {
      this.cent.on("connect", this.props.onConnect)
    }
  }

  setToken(token) {
    this.init(token);
  }

  reconnect() {
      this.cent.disconnect();
      this.cent.connect();
  }

  componentDidMount = () => {
    this.cent.connect();
  }

  getChildContext = () => ({cent: this.cent})

  render = () => Children.only(this.props.children)
}
